import React from 'react'

export const PaginationList = ({ children, className }) => {
  return <ul className={`pagination-list ${className}`}>{children}</ul>
}
